import { render, staticRenderFns } from "./AssessmentPersonalData.vue?vue&type=template&id=5d5b65c2&scoped=true"
import script from "./AssessmentPersonalData.vue?vue&type=script&lang=js"
export * from "./AssessmentPersonalData.vue?vue&type=script&lang=js"
import style0 from "./AssessmentPersonalData.vue?vue&type=style&index=0&id=5d5b65c2&prod&scoped=true&lang=css"
import style1 from "./AssessmentPersonalData.vue?vue&type=style&index=1&id=5d5b65c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5b65c2",
  null
  
)

export default component.exports